import { useEffect, useState } from 'react';
import { getThreatNotificationConditions } from '../services/manage/threatnotification';
import { ServiceRegionType } from '../type';

interface ThreatConditionsData {
  conditions: Array<{ value: string; label: string }>;
  hackingTypesForAndroid: Array<{ value: string; label: string }>;
  hackingTypesForIos: Array<{ value: string; label: string }>;
  osVersionsForAndroid: Array<{ value: string; label: string }>;
  osVersionsForIos: Array<{ value: string; label: string }>;
  loading: boolean;
  error: string | null;
}

export const useThreatConditions = (
  region: ServiceRegionType, 
  authContext: any, 
  t: any, 
  i18n: any
): ThreatConditionsData => {
  const [conditions, setConditions] = useState<any[]>([]);
  const [hackingTypesForAndroid, setHackingTypesForAndroid] = useState<any[]>([]);
  const [hackingTypesForIos, setHackingTypesForIos] = useState<any[]>([]);
  const [osVersionsForAndroid, setOsVersionsForAndroid] = useState<any[]>([]);
  const [osVersionsForIos, setOsVersionsForIos] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConditions = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await getThreatNotificationConditions(region, authContext.token);
        
        if (response?.data) {
          const { 
            notificationRules, 
            hackingTypesForAos, 
            hackingTypesForIos, 
            androidOsVersions, 
            iosOsVersions 
          } = response.data;
          
          setConditions(notificationRules.map((rule: any) => ({
            value: rule.ruleId,
            label: t(rule.code),
          })));
          
          setHackingTypesForAndroid(hackingTypesForAos.map((type: any) => ({
            value: type.hackingType,
            label: i18n.language === 'en_US' ? type.descEn : type.descKr,
          })));
          
          setHackingTypesForIos(hackingTypesForIos.map((type: any) => ({
            value: type.hackingType,
            label: i18n.language === 'en_US' ? type.descEn : type.descKr,
          })));
          
          setOsVersionsForAndroid(androidOsVersions.map((os: any) => ({ 
            value: os, 
            label: os 
          })));
          
          setOsVersionsForIos(iosOsVersions.map((os: any) => ({ 
            value: os, 
            label: os 
          })));
        }
      } catch (error) {
        console.error('Error fetching threat conditions:', error);
        setError('Failed to fetch threat conditions');
      } finally {
        setLoading(false);
      }
    };

    if (authContext.token) {
      fetchConditions();
    }
  }, [region, authContext.token, t, i18n.language]);

  return {
    conditions,
    hackingTypesForAndroid,
    hackingTypesForIos,
    osVersionsForAndroid,
    osVersionsForIos,
    loading,
    error,
  };
};